import { SalesStagesOptions } from './utils';

/* eslint-disable max-len */
const texts = {
  filters: {
    [SalesStagesOptions.ALL]: 'All Leads',
    [SalesStagesOptions.NEW_LEADS]: 'New Leads',
    [SalesStagesOptions.FIRST_MESSAGE]: '1st Message',
    [SalesStagesOptions.SECOND_MESSAGE]: '2nd Message',
    [SalesStagesOptions.IN_DIALOGUE]: 'In Dialogue',
    [SalesStagesOptions.CALENDLY_SCHEDULED]: 'Call Scheduled',
    [SalesStagesOptions.FINAL_STATUS]: 'Final Status',
    [SalesStagesOptions.DUPLICATE]: 'Duplicates',
    [SalesStagesOptions.MANUAL]: 'Manual',
    [SalesStagesOptions.FOLLOW_UP]: 'Follow-Up',
    [SalesStagesOptions.PAYMENT_PENDING]: 'Payment Pending',
  },
  onCallLabel: 'On-Call',
};
/* eslint-enable max-len */

export default texts;
